import * as React from "react";
import { PostDetailsDialog } from "@/components/PostDialogs/PostDetailsDialog";
import { CreatedPost } from "@/interfaces";
import { ShareComposer } from "./ShareComposer";
import { ShareFlowProvider, useShareFlow } from "./ShareFlowProvider";

export interface ShareFlowHostProps {
  /** Initial values only: the session player for players, null on coach screens until a player is picked. */
  playerId: number | null;
  playerUserId?: number | null;
  onBehalfOf?: boolean;
  /** Screen-specific refresh, after the host's own invalidations. */
  onPosted?: (post: CreatedPost | null) => void;
  children: React.ReactNode;
}

const OpenedPost: React.FC = () => {
  const { openedPost, closePost } = useShareFlow();
  if (!openedPost) return null;
  return (
    <PostDetailsDialog
      open
      postId={openedPost.postId}
      socialNetworkId={openedPost.socialNetworkId}
      onClose={closePost}
    />
  );
};

export const ShareFlowHost: React.FC<ShareFlowHostProps> = ({
  playerId,
  playerUserId,
  onBehalfOf,
  onPosted,
  children,
}) => (
  <ShareFlowProvider playerId={playerId} playerUserId={playerUserId} onBehalfOf={onBehalfOf} onPosted={onPosted}>
    {children}
    <ShareComposer />
    <OpenedPost />
  </ShareFlowProvider>
);
